import { Vue, Component, Prop } from 'vue-property-decorator';
import { SiteListItemDTO } from '@/../client-generator/generated-clients/sites';
import AppTimeAgo from '@/views/components/AppTimeAgo/AppTimeAgo.vue';

@Component({
  components: {
    AppTimeAgo,
  },
})
export default class SitesListCardsComponent extends Vue {
  @Prop() sites!: SiteListItemDTO[];
  @Prop({ default: false }) showLastServed!: boolean;
}
